import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import ChatWindow from '../components/chat/ChatWindow';
import AppLayout from '../components/layout/AppLayout';

interface LocationState {
  initialMessage?: string;
}

const StreamingChatPage: React.FC = () => {
  const { chatId } = useParams<{ chatId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  
  if (!chatId) {
    return (
      <AppLayout>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="h5" color="error">Chat ID is missing</Typography>
          <Button 
            variant="contained" 
            onClick={() => navigate('/chats')}
            sx={{ mt: 2 }}
          >
            Go to Chats
          </Button>
        </Box>
      </AppLayout>
    );
  }
  
  return (
    <AppLayout>
      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Button 
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/chats')}
          >
            Back to Chats
          </Button>
        </Box>
        
        <ChatWindow chatId={chatId} autoStartMessage={state?.initialMessage} />
      </Box>
    </AppLayout>
  );
};

export default StreamingChatPage;
